import React, { Component } from 'react';

import { OTSubscriber } from 'opentok-react';
// import CheckBox from './CheckBox';

export default class Subscriber extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
      audio: true,
      video: true,
    };
  }

  onError = (err) => {
    this.setState({ error: `Failed to subscribe: ${err.message}` });
  }

  setAudio = (audio) => {
    this.setState({ audio });
  }

  setVideo = (video) => {
    this.setState({ video });
  }

  render() {
    const { videoDimensions } = this.props;
    return (
      <div>
        {this.state.error ? <div>{this.state.error}</div> : null}
        <OTSubscriber
          properties={{
            subscribeToAudio: this.state.audio,
            subscribeToVideo: this.state.video,
            ...videoDimensions,
          }}
          onError={this.onError}
        />
        {/* <CheckBox // may need to add functions later
          label="Subscribe to Audio"
          initialChecked={this.state.audio}
          onChange={this.setAudio}
        />
        <CheckBox
          label="Subscribe to Video"
          initialChecked={this.state.video}
          onChange={this.setVideo}
        /> */}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/messaging/videoChat/Subscriber.js